var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    fill: "#cacaca",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 256,
    r: 48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 256,
    r: 48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisHorizontal);
export default __webpack_public_path__ + "static/media/ellipsis-horizontal.60d150785b32f2dbd3b138bda2b75005.svg";
export { ForwardRef as ReactComponent };